module.exports = __webpack_public_path__ + "img/3.62ee5fc8.svg";